import { render, staticRenderFns } from "./AccessibilityReference.vue?vue&type=template&id=709ca00b"
import script from "./AccessibilityReference.vue?vue&type=script&lang=js"
export * from "./AccessibilityReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports